import MainView from "../components/mainpage/MainView";
import {
    MapProvider,
} from 'react-map-gl';
import {createContext, useState} from "react";

export const PointsContext = createContext();

const MainPage = () => {
    const [points, setPoints] = useState([]);

    return (
        <PointsContext.Provider value={{points, setPoints}}>
            <MapProvider>
                <MainView/>
            </MapProvider>
        </PointsContext.Provider>
    )
}

export default MainPage